export default [
  {
    "id": 1,
    "nickname": "小美·716",
    "userId": "1954365742",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/05/BMjAyNTEwMDQwNTAzMTNfMTk1NDM2NTc0Ml8xX2hkMTg4Xzc3OQ==_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; bUserId=1000277756247; userId=1954365742; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAH2sTqElapJCBuQXx824rktBZy2cfjRAktuDPKXk5N7JvL9EynBN7YvGaV_kA-yWul6VMoQQ8i9ty8HJ9bmMFN5P58vhIn3uQXMIfX7e5Dcav2S3Y7v1hfIFWoUWsz2-OgYfXxigHP-pkWGbBeoaFdo845sQTQRXaELOmhhNUBKXqrk26AY6Ls4WUPCJQHGwCi0KiiZqCBFl9JWD4rRNaaGGhIDc-qPTdpdt2c1Eu3bbve-xL4iIGocWMpLNEVIA0Qxi_FfE0TKH3xajV5CQqhEc9V3Y41wKAUwAQ; kuaishou.shop.b_ph=6be456581625b4523c9d623addd5c37448a1; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAUffAqqihWvXjfdEn__NoxfQ_wfKikzP3vlcLUexHZZ564ehZLHl-p4f__D3VxUIUAdRUxbbN0CO0gKZ2g23NlrcHVkUQhWCKiA2mm7hAMJfkVecyB6gBnat6g50fPm7RDr4vfX-17S9c458VRWFunhCy_AQGv1HEpFPedw6z6d3TSYNSZ6epsLY_oFL5YrYzE1bQf29t_NFwM0g-qdXiiN6cxXd2tJ9SxJECXQ_qNMYGhKd4QgDwlODTx7HY4I_0IJB44IiIDezbm8jGELPnKVyKUR6uL7DHONlVCZjFt5eGbyIbFQnKAUwAQ; kuaishou.ad.analysis_ph=34b567bdb85ef1d772149f66b21d4351cfcf",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 99999,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 2,
    "nickname": "娇妹儿",
    "userId": "2131929203",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/11/25/01/BMjAyNTExMjUwMTEwNDVfMjEzMTkyOTIwM18xX2hkOTNfMzAw_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; bUserId=1000015505141; userId=2131929203; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAEWktlRIThKr8bsrbcJIz0PP6_8xoQDTm31zUvrkARrVS9hisUAA0q0cIyHsJ90VZgDkc7xDy835Zj3di4nbmx1eZkC1DfHRJvafkEn_PCJpiQS06RnP77b9wEGyw8Ng-_oR4ZYLIXW9UgDUCzRKpvaiWypNN-gqhVbZ1CtqqfFoWxGprN4O6GtmzdR8rsYpsGWS2IJ5DTkxdF9s-tPfE_xGhIDc-qPTdpdt2c1Eu3bbve-xL4iIE9HO7kytfK4NJtNDQSCD329SIAJgwrZIP_eR7REiaAfKAUwAQ; kuaishou.shop.b_ph=66a07ebd430ce00ea66df085d3e26055d27a; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAUx-934iKjEd_Z5F9U5RKhiBkbkmS8MetNvGshWECPts-9m7j9pNkxclNQiPfR0FQF1bO2e43a0AyuU7QZBOgwJTFF7y46S22drwXWiw4_F1aljAfAxZgsGTIFiTf6wVgtH_dMmeKxbNqdVf827Cis00U22gV8eYYUt18R_Qsn44_-ODB6L3u5x9MInplEL5Djrmw3Zkbf1ZmC88RNrwqleaHNHoh0eZ4jnLQQchU5jpGhJWN115Ohj4xUqktV1Hvw_z68kiIEyJMSS_GjqNZgAZIh1jI6diXGW7AJDOrqHFwxzxj6XfKAUwAQ; kuaishou.ad.analysis_ph=474ccfe18e207d041ceb17309e45fbe19514",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 99999,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 3,
    "nickname": "嘉文🌝•716",
    "userId": "371800776",
    "type": 1,
    "img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/04/07/BMjAyNTEwMDQwNzQ1MTFfMzcxODAwNzc2XzFfaGQ3NV81NjI=_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; sellerId=103432682; bUserId=1000015505412; userId=371800776; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAE11sw4BtawPHUqCEU2s1FZ3kZxK_nemg9ALZGTOxhxqRXU7Sigtpn00NvxoLZKO0zrbsI98VaVsXBtKSvn54BRQ_hn_C2p5ZoLnVH79ScogpzNiY5-NyC1bC_mJtbr3Ii5c31JUq45TAuzjagVX0RTEPBG5APs82MYNOfj3wyHwPdn6FnJ7aX-625Ei5UhiuOWljQfaKb0xxjMdB_-SGydGhKbz3TbRj8_GqdtJns0FBl2yz4iINMdFTZxxmwq8xeaan3YpXJgcC7wNWkahEAGcH7Frg0YKAUwAQ; kuaishou.shop.b_ph=399330d97601a1bdf18549d3e8103364c940; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAYuTFDTdp2nr9ckm7Tjrnvbyqot67EJe86quZvqM6rf6DPvVn5nnT0W5HxuIi-cq6FlfMjfaA-oq9N-9lvm1-KXaempXa2Bo_OmbhYHPg9qbr-1CFNis0XXNHDl_4N-Ff5wMAJ4pvQL8FjA471S-OTlXIa8AbUWsFIwE3Ea-pLSMXevlIxJkx19c2xg-8oxuLIXySBzjEYix_EMPXZEZq4IUuVKTZ_4RFSjkhVSagO6OGhKeNFIlcbXS9CWSbj9ULtqm_ikiIPsPqMi3NHvuwZ48g4_xFNiOGs4q-S5LiUi8206wq7JJKAUwAQ; kuaishou.ad.analysis_ph=eb61626fc1647a30262cbf528c334391760b\n",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 600000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 4,
    "nickname": "金牌志虎🐯",
    "userId": "8427947",
    "type": 1,
    "img": "https://p5-pro.a.yximgs.com/uhead/AB/2026/05/08/09/BMjAyNjA1MDgwOTUzMjRfODQyNzk0N18yX2hkNDkzXzk0NA==_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; bUserId=1000010986245; userId=8427947; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAEj0hO33qaH8S4tvw_8X_UwfnafIke7MvanC7HvFFDDWZSF58Fu9JYMmqn4UmWLi3cKCQmtBus8RFZlSBK8ZAn_4E9vwrkWcNYitiGjHQq4HRACRx4EXYK4jXKAMP_1jAAd5Z-6CS27Ji-vYmnmIu03AZzRpbCPVnZgNwFHcL83gRGj-fBUNAkH43bBhgf1-AC7vsst0uHVfoHaISf7DU5mGhKWjgR0Z5KY20AASC-Mzxd_Ru4iIF2-3On4xUM-jp7RzNxypFx7SX1tHsAchb5H-zS85LwmKAUwAQ; kuaishou.shop.b_ph=0692bc08a14bdd02229fcf3983743e0b6737; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAW8EREJcwE0KKT6NQzgaZUCt_X3Dh7ucC-3b2_DR2Nnmp1_qJOJQXdrZY7q8n9Qqe8voGA1gvcLc_8dXiHx4oJWoMMJZmsdMzv2Wm62_GVs8QDRwdvdxoSBrcPuhtWkDd4kM46OyJrIsMN7zM0SN4Avdvratovv33_c0eK0lgMHNUkttXTzL9UzBCQl5DBRP8su50Wfx8a0_64gCvvCcMxFbKSr5J7h-oVXtRnmmbNYGGhLD0lY79lZNUc06quXcO9APrxoiID5Dk1Mb1NBcJ8ZP0KE04wDrxRLIGiDES5uuZhpCjJDxKAUwAQ; kuaishou.ad.analysis_ph=11463a34fb2803f94dd413723f9a73615ab2",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 99999,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 5,
    "nickname": "天启•716",
    "userId": "331833119",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/18/BMjAyNTEwMDQxODM1MTVfMzMxODMzMTE5XzFfaGQxNzFfNDMy_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; sellerId=103432682; bUserId=1000004423636; userId=331833119; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAEDgMxnRoFBEAN-NXcVs7VEqIg2eRFITOb11g44RfylcDbXeWtkfF5XMtuzixj4PtCVlJuOGHEO_YNzGovERe4MIxtB7eY7HcCc5DZdHL5BqEcXSpyRQ38mRFoU5OHI_YbXMvbhPFXUy8fs3mFcPpg4QURhcyfOnyzqQ6n5r29pRTrmuWxXs_KS7_6b1G49E62M-Gnkft_FqDxw7g7mPdPhGhLzLRQKxP4poK4hR09Wrd9HhuIiILZ2pCjiy9iuDTCB6NNAGozvL_1wvdVMMt8hTmERopJqKAUwAQ; kuaishou.shop.b_ph=7fb3dce65552ccf644641b7229b86ee1cf4b; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAR5QaYwckcZdi9G4TNB4ClgKnBkqecMuWbaHSXCR4G0xXyfZyy5IIYIC7EXxGsNXhGScCmkXW3Ve5jKz0m8kkyjf_GynjdQxY1Cqnv67K14pUnAxxuKKRO-LhRiuxSF1yYhQ83xRJtqqZ7zgaI97VRxEe84D2fa15qDxV4vR8Z0Z4dNBvCaomVILnXAELqi5l5Cs3npKaLm9o4fjb0ynLaNZyUOPh2mHZTbN0JGEFlDlGhLUDbQSvVB4bdfEWaIuXM0UUl4iIANVoUycuVV0ng5Zodhl67jFE5TvXSadnFqqSNPpowaxKAUwAQ; kuaishou.ad.analysis_ph=6f7734450af2a430ecf9a70842c06e05c22b\n",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 600000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 6,
    "nickname": "懵圈妹妹",
    "userId": "16194648",
    "type": 1,
    "img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/06/22/13/BMjAyNTA2MjIxMzQ1MzVfMTYxOTQ2NDhfMV9oZDQwNl81NDQ=_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; bUserId=1000002415749; userId=16194648; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAFqdeOtzo8Kd3WLhZ5za8P-rFAnmb49DfyXtpp5-OSGZXVHxFInRifFFHLNnZEU0tqLX7SknceITBVx_Lx5GUGMu8F7xZ8xowXdqHViTdMK8KPjFdu1LaEpZ8L2ZWcyShCBNY2DI7UwTEreuyIAdBRdwl7g5PtT5hXv9pANkzS5v6f-D2X2bVCr4QBO5nN4UP0h0CdsFnIUxgUUlXagPlkDGhJSPwykspxJ_lwL1FDHlEAhP1IiIEeJtEIBno_v5vc1_Wv-91A9FvIQZNgV8xq_2mXhF0lZKAUwAQ; kuaishou.shop.b_ph=aa1e45475b77904e13656f45c5260d2beaea; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAWDOh7sVC1Ma_tIkBux4z-tA5M8u42WuYIkrg12s3i01TphL6aSW9d2qcHMnvzl7HEzZVIw1RiTwU7krBZaQqkOiBLdxk9oixm6hrt3xGjawo6X3B4osce7QP5AWOECEsh-wwJ_s2hRkD21f3tfEFHjPshoDv8mF8Q3Y8foTin1qs-e9Zrc2oBgH_ZbulbfekVd4_YCVZyu2zhvO3Ac-ucAfwIrcB4W1_Pyv8HNgBBOZGhKi1FaAfnwIV9YBgY4y89SVJA8iIPNQhVx5s9ilU5REElr8VelR0rqDvZfaObfoB7bM5CF0KAUwAQ; kuaishou.ad.analysis_ph=063e3479bf14c47c5b3470ec6a686ea73c32",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 99999,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 8,
    "nickname": "陈小夫妇•716",
    "userId": "29982331",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/14/BMjAyNTEwMDQxNDU0MDVfMjk5ODIzMzFfMV9oZDcyM183MTE=_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; sellerId=103432682; bUserId=1000012931692; userId=29982331; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAESBdgyaSa4Y7sY5a80BwC_XERnwYU-cUNdzQxzz29fUq20OGFDY_4TcWDc1vYWuQ18-wo7BoPBHv32INYmuAFPT3QzrDWrTQnS2mYCPTuNItRz8Rge4S4SsB-8Oo2QqisXEggS_B8kAHrtsxgWRT5Zoy6fV4UEua2kO37SvnjSkdWqoj4Wv5Cr3K2zWKHvd6oqSiVAPjDYkLshD5LEOqznGhLo_Z2VG4WxceKArz4eXu24hPEiIIreiCqkP4LIlMjyZ8LNcDULWoUhcUdBSNsn-Ke8TZfWKAUwAQ; kuaishou.shop.b_ph=bddae15a952660aa44c7aaea81bf64b48c9d; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAVVKHxgbzzqoWULIHSDhVV0TMPLbMCGJXqfF7mYYB3NDcsdxkSeiIhRwogL6kaCMfpR7OSX1opZ_Rufqn9ZpdCCsRdLbgJwaUBfTT_NeCrlESmDWTgH6m1no9xMd7mBvFsj0Zd-JiY7ojC4ChqbsmQy95wgK4CIRo9EEP4fSNhgw65pQnpu_Go45JtUGRm0_fH-1yo_FvZ0FRN1C7be3VkBAaA1UJJV4PCtqiHQED73tGhIszidpTUyKE-jZUURCKcG_ackiIDp7wzdKkGNXWNH2aQFnmTHmM2RwobxrFbTWe1CzJuxXKAUwAQ; kuaishou.ad.analysis_ph=6b493e510f995074b46da4d213645dd1b4eb\n",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 9,
    "nickname": "雪儿·716",
    "userId": "11569700",
    "type": 1,
    "img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/04/14/BMjAyNTEwMDQxNDA2NTdfMTE1Njk3MDBfMV9oZDM0Xzg1NA==_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; bUserId=1000011505740; userId=11569700; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAF4JFPVJGphidp0byx5n8iN7G7C-TrgP0BR76P1RDBAndjl0603a3PFOjTSWP1OixYBZf6GOMfh7_XTQhMsRT4QaNOTNSsDY-Gr4OTho_EGvgLEJtUtT54iPQ4G7gs0JLbEj0SYEY16R4m7rkhNtZvwLnd4SvygzUCTvhK2BoByEGSl9GmpZX-DX1XrfsNkdq6WJgIH9yQnLNsyg_72U5SNGhLY1PpTmwXZ7exgP76r5BIkpxIiIHfHtnPk4cukMX4KBHjrfxUkhiYmrBCgYhiKUO1i2HuGKAUwAQ; kuaishou.shop.b_ph=823a86414b334a6adc6590693ce7bf2b4d29; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAdXRnRr8ZDu4kyGAQhkWawf5Wv1ocCPYxlXn8zYLX5n6L52UGEEJ1ELQpHavf2r2y8dXXb7pgsLER4WXtSmQqUR9sHbIyCFGpLpkguw0110Cg9L_-AsNML7rE1D6RFcufRr-A1PkgvG4e28_KdmwWJ2_lHMZOJsSU0z0u-7LaKjHk2AiCD3rL9I9D5AjCO3GhQ5GHIsT_1FrzK_zJtihWl-HoBaiiQdL9A603mxo-MoSGhIQN0ywTnpD2S-JIHMxDcdXAQ0iIAmDz_ekyKUI59Lr8chz-cFD9OwPuWYO-s8fgo6JEAjUKAUwAQ; kuaishou.ad.analysis_ph=e5d5cca4721b29bfe7ce69c8bc93861a2a82\n",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 99999,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 10,
    "nickname": "依玥•716",
    "userId": "228816049",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/16/BMjAyNTEwMDQxNjE4MDNfMjI4ODE2MDQ5XzJfaGQ1NTBfNjYy_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; bUserId=1000012466271; userId=228816049; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAHxD7qPB5BT7ohSsEo1vzbQDDrER0Sfyl1XM8GvuwcRvZoGR0eARRI-jyf5YO80i9eUy0pB-Kf_9pIVw2IBnljqbdOqsuswVaWN8sMT_Uz0STvdia6X0f_dvZPkfY9kkurAvC4EIHcS4bmfPVRV9ySyPzh21EQimTeJHaDG5yHTN03LRE4VeQdgEi74RpiPRbYs55r51iUkDs7WVb76duqCGhIdwFBlxRpZgyh6i0Do-DSRsroiIId6X6MXJc8TXWIdNHYOph-OrWARqAIVDSUWeLLPQ-yQKAUwAQ; kuaishou.shop.b_ph=739088827840499fd464f0d9faaab437afa2; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAfG7vRUQaY6QWbI53plJRnJMLX5TIBMueB1BUncq4glKl5Dn8REDZD8rc_0-TsQ3HS9kusHY2CCkIAB1i-3a9wmfe1n2liShCgBIi2dXG9io5eg8HG8FJrumClGSePX_T841jB1WNztXNr2b2wR3H6-uEDfQS-_aA7BUvPhmRBHgturSq_2GQaYE36spCAcg2qTeo2jV7f4Oq8ZhAKHxGZPSTZOyK6TpgMZkR6FMRpuXGhLbwz68ZkiTB3sY69L_Qrle9OgiILzCEobOb49r3_cYzH5bEW5sRU2lli-ftX1W-c41QmBoKAUwAQ; kuaishou.ad.analysis_ph=8053cde5150d8cfe775dac087229ba02a8b3\n",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 99999,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 11,
    "nickname": "红妹•716",
    "userId": "511012459",
    "type": 1,
    "img": "https://p5-pro.a.yximgs.com/uhead/AB/2025/10/04/16/BMjAyNTEwMDQxNjA0MzRfNTExMDEyNDU5XzJfaGQyODBfNjE2_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; bUserId=1000011283039; userId=511012459; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAE1v11IuVCNSBcEYEuo2nJ0njDKsgBqYu5EvhbxN4guvsYbX4k22E61YYlWcC92VsbeJCcBtwpCDwPsHqAYkCBYje22cyrU62lLVusBVwCp0IiTTslCxLD95WBJXlzmgG1wPbApuJ44MhlBwpbQLPiBOk3zAAr5LHvMOBH8DPD3mZQ-ZCdLnYFPfB5Od5y79h1fFLxHlIyUj08omVujj0BWGhLSubyi-uEBAthqCoUoWxNxjR0iIJqOFu1zgYeK0vhZBE1FzmYfm8YF2XY6bqk9sNcQp_RPKAUwAQ; kuaishou.shop.b_ph=476d234390f2649bd46b4873b31077d8d85c; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAb0ymbVHZrA13kSDJk1JkRjrxLFPGR8gDmsSC7dLSuxnVjv09fUSO9tt-wGKc7C9llqO-8n-0NSHUJsuorIxsVD0eK4454lf7bFDhvqcJShSwgfqHqpOkKBjU2V9VUIJHSYYTIKvkIxJ7suZL7Ps8LoZHubXhaAXgHF5O8Lhh5pfQMyjFrjjqvRPPanWIzLNadqw7Z3J_UKsMTVZ9x1D_3SsI7dUwAnTz55hb-VVibfeGhKd4QgDwlODTx7HY4I_0IJB44IiIPdfFNbU2_sp5hpjirU_XY2Nt5fznqH_UqWI-LYBqyHtKAUwAQ; kuaishou.ad.analysis_ph=0597e1981079ab206255528e6fd26d397179\n",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 99999,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 12,
    "nickname": "菲宝•716🐰",
    "userId": "50913379",
    "type": 1,
    "img": "https://p5-pro.a.yximgs.com/uhead/AB/2026/03/16/21/BMjAyNjAzMTYyMTMxMDRfNTA5MTMzNzlfMV9oZDM4OV8yNTc=_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; bUserId=1000006868736; userId=50913379; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAFANjplsxr1ZdYfofTqBqda2oV3V5o-abLsubJPQqbTWpa4acorJsN5lIChTf5lt3LQZsvxZNnBEjcN0nf7fwbWKXcOix1YeHMp1qjgLeIlkdCUtJyiWbtFjEAqanBxvtD4SFV0JfnmQVHDRKgV_x9DDFGUsQAFNmCtN7nPPd4XR95ahvH3NCrn6AHQiS6PbD37-CS-gvppVt7acmhRD4NOGhItLX8o8yblZLeUpJbxgb-W1KYiINCYAciFY1tc_CmtTEwG4QTjVjigsZ_W8dOdL2G3xBCJKAUwAQ; kuaishou.shop.b_ph=26f026997ca24504717e65e920d7d3bbb816; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAWtd7QfPXckhvAdmmTNlmo6tE8PAybXgjaj9oq49yaCvaGSFAfeo92vQk3gfdEyWOR9StRhdru6w21inTWQ2BcGfnIQpFjV1apajPBUA6evLR-g4x5E8IiZX75DLf21KStnvmHRXxxLcNCFe9xDilYSQAZBizCkhvdp9Vnfl15WnLjw8hE-ajsWOkpH8MZynB3AQ5hDtR9t39TUB-9UQksQBx5Fl_7F8ZIDtMnCq_J5HGhIwLKC4NhkvWYzHWIZ_6D8fDt8iIP_BdWECoGamafBA32YS_TK37HzBzUvqdWJ-6qUUfbLrKAUwAQ; kuaishou.ad.analysis_ph=439c5b9148377aa3d68cad6546740d9c012f",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 99999,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 13,
    "nickname": "温柔曦•716",
    "userId": "1256295378",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/21/BMjAyNTEwMDQyMTAwMjFfMTI1NjI5NTM3OF8xX2hkNTc2XzY2NQ==_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; bUserId=1000014891048; userId=1256295378; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAH4UHG-jocCW4KhU1LvBxtQDteZ7ABC_YcjhBKFJteF3QEHc8g91smsJIJySGENd2XQcMxOuKZYMvyKFiVS0DvLz6pImVak2A_snnl_Dk7tWgNdGtoAJPnz-52rFuFOD7zthTQm05hX1KM1xC4yWYKiL45vO4zxZ_F85sJFY4gPX7OhZ4QEMgaWNLaZo8HaxhjAXv4Rffs2dEI3wmnYKMVVGhKmF-W_lNyJTm2KnbtfN4jmymsiINEN-bwQldxJ6oaNX9_TsHlfycGmOLbVcYjuyeEE23VwKAUwAQ; kuaishou.shop.b_ph=b93491d26c5bed0fc5143fb4e852f495ae94; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAWrpnRxcqHsm6dzZUdChtAhLFufsw0rPKPCsHJ4B9oJpnQGoIqGbePfk2neuFnKPe7evtS0BpFjrIQYMQmnaoMDruHemdGakrpTZ5iStNMYZ81Zv7a3b-OIZ_nlFq7UUCGH4AhaYXE7uAtFdkcJNqxKhfewsBulGaHesBZ_jJGXA6d1hZx3CjYdeOE1RleEx3fc-5aDa5Q5P6s3ujSF0oc_piZ-TU6E0KEJ32G2RPbAjGhLJQvUwrfHcDOIi8qefbDJk8MYiIKwcHoKTxCpUUevHmLqzo8kslR5vpjmmb04-e9LGvoAZKAUwAQ; kuaishou.ad.analysis_ph=2cacbf8dc2eed9f0fcf331cad4d7d70f1b52",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 600000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 14,
    "nickname": "奇妙冰•716",
    "userId": "47532992",
    "type": 1,
    "img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/07/23/BMjAyNTEwMDcyMzQ1MThfNDc1MzI5OTJfMV9oZDE0MV8yNjY=_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; bUserId=1000015113075; userId=47532992; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAEXJjePzSpHpkXdZdm4pyuwQ_gYKB0czaR7sw2PqGHS7SnGytptx4c1-DWoGrMGOkL6-dQKD0MofQacMHgc3VvBEMabDW2r5fPeAtVudsv9mkO4FBYMZ3jY3BNXN8Gw8cBeZEnMQmDEEXOPemmKQSpGYtPNzZYeWztDTGpdAfdbsUT3Q-01l-RKB1Wjng0OrtjUEt3orYckY4MgSUErrWFjGhItLX8o8yblZLeUpJbxgb-W1KYiIFo_5v3-5e0fYxuirigeZbWxlsM4rZmd2v33Dok78BQRKAUwAQ; kuaishou.shop.b_ph=b71dde2bbdb35ae3d463ddd4c5c500948226; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAcNtvvcswq3l380596VaB3nXwZbxaVfKjHKKNgNjmTLFJ6NdpeT0BmD4Po-LmclRIi3pSv5_9vuo3I23P843dmG5LrQIeEb1-blqFnVIg7jkFpClRAYKxtPzgOOcqc9_xIxw665CwBPSMS-wcC43zDxIHTokG06sT_KXc7eAm-CuKFXU6vmp5aZi_y-7nX8lIQx0dZ2UFX9wCRz68p8A8921Q3y8dzHv1wOLUVYsx6NCGhJfD1LIXix5VNQHFXrUrql1j9MiIJPOmEbR-MmiJviXiadzEoVz0A2ju5FKL_p3ks_-92aQKAUwAQ; kuaishou.ad.analysis_ph=3ada7325d55858718c135c96b526eda7e41c",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 99999,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 15,
    "nickname": "娜娜•雅儿",
    "userId": "2454678977",
    "type": 1,
    "img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/10/21/BMjAyNTEwMTAyMTEzNTlfMjQ1NDY3ODk3N18xX2hkMTIxXzU5_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; bUserId=1000012465986; userId=2454678977; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAFr6Hq26ezlQtGvCQeZAATXFQZls3JCxHpnn6FJ7IozXEq6jPw-y3ezgc8ArRt7iZPxR3sdXnqGQ3pvWvyvprkV5-o3nI0IzeXxV70ne24QzQxhifcTyl7-eojEeVoS2m69UCYxi_P-L_6c89ydTfMPgKqyMDGWbFx05KIVTcnAS3NJLWnwIDYe65Ncn9PNs6PDhXBYj9Dn1i9SOoIVb-_fGhJ4oTBo9TU9zBxgYX3KzGIfP4YiIEcLrLHDX19lxYOKDl2sjrO7Hb0cQvam8Zt-0dzS4b7uKAUwAQ; kuaishou.shop.b_ph=eb45819c97c543a3be63d7c340c57c710ccf; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAfd8UopAcp6wCxZdj-vIk2yzCig3Uhc43hhHmoA73EXlVDd3tsYXqFY8qwiGpJSu9klRkwUX8jOohIzpBwGehAzYU5iVv8kRnyHuP3hzB_O9VrV43PTkbQrUT-6G_-oid7LAfoGLqUUruURElSyimL4slxuJZPAmEXqhSInrmW01EpC3NUtwy5-QL0oMVRIxvvZJLtAP6r7AdNHHigUD2Ff0nWjsYOuhhG42M3CUbAdsGhKZCfrvDkZPW5JtsdB6aD7xPb8iIAPsdsaK2KFobBNaUwkLkHzXPC0jkODaHsUFPxFFb5nmKAUwAQ; kuaishou.ad.analysis_ph=851688b848f6840bb334ffa89b9e06a62b59",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 600000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 16,
    "nickname": "萌宝•716",
    "userId": "5913072",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/07/04/BMjAyNTEwMDcwNDM2MTNfNTkxMzA3Ml8xX2hkNTgxXzcxNA==_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; bUserId=1000003531885; userId=5913072; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAH7r245rVWM88X4j_DO5VpH8MzssFKfUnPW0LwZ85nUtTAEUoLaSn5GEcLIloOWvDCUVtMomCAhXT5eYnjMB0n-jnADZ2AuVmmzll_llLpasLLYY0BlxMtoUTUK-m4dycCQ3lgLxwkFqo4j6J3AKcS6mwdhVPYFHNahrv-pu6nurp5Zda2CUN-sQZ11O5G-tPBH6-PkSPj2PwJQP2rvKd6uGhKmF-W_lNyJTm2KnbtfN4jmymsiIMJeOcz2FENKVu_IjIeYjaCavVJMU6JR9DaTojQpvptDKAUwAQ; kuaishou.shop.b_ph=5dcc493084c801468495046b3614c508bc58; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAQF2XOsG2IczR4ye52V5VLLp2lBDwNFpctoveEmRyRP3clhZkXQ6LvfajSOQSmxtRPxXkaLMvIOcukLRblMjXtvtZmGQZPAjnW1Pn1YLQnDt8RBSiWdEsFuTdibmN7ZM0WwsCA01BwvNGt9iZjp82zfv_ZvufVKPTL8cTNeMcF9zFv1aoi4AkBzF5GIqM21FIps8qJIksr0wBILwwb5sOD4KgCJdHmsy17s85wggi4NuGhJTq2ODdjhJ6SRw9AjqUvtEh54iIOmixrDDAYwYQW-Ye0_t-3-e0K4ETEwOT5e6MbBazLZmKAUwAQ; kuaishou.ad.analysis_ph=d004072251c5b0ff96c3fe90818c75311c31\n",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 600000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 18,
    "nickname": "雪雪吖•716",
    "userId": "8940989",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/10/21/BMjAyNTEwMTAyMTIzMDhfODk0MDk4OV8xX2hkMzk1Xzc2NQ==_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; bUserId=1000014891541; userId=8940989; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAGEN1qCjLSqjXaAqTq1-MUvPoSKK-5AiXvPRKk1pzJcA4tcR5TKSNTkCKJLF4M141asRz7n9KYcmxvBOu2_Kx3dIcnzZm8Fhq4yXVix_Zp0wNhXbbE8wxQnu6h3Tc4fue0uQxtrxWC8LGLvM3BzAoNAZ53eiYRkNF1XWkV4IOc_QxOa_nA0k5rY7fdCmMQaKh_sU0z1Y6uTCCJjlYagL8ZEGhI2yYASXgUPN_H6NBCr-rCyOd4iIF4iiyxcBxWcqXsK526BM9UA6el1ClU9VJhOtBc3IiVGKAUwAQ; kuaishou.shop.b_ph=3e625f832ab70c5ce00b82561deac1e445c4; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAf9kSlxiCosC8UnassvaE8AjdhTmgl-IT6QML_96Ejv7qZRz2fq3rE3ZtVz7T5BPryQYrWfG93_cvRXu2nciSqZfbWdZU37F0cZKQ3ce7AA-fzIfQyNfvB0WdxALH93a0NufrFtvDMgfp9c6jauh2wcpsVDh3XkSCy4T4kug-ZbBCaVr1ywewdlR6LLEGP8R9FfLKW27FXc4SzsVlX0HqNVTNQKsF1UTFE2fmzjnfhgyGhLp8hicmEEI9gcCpeePxY__tVYiILZLCfZytUmvsq54evPRpgo-FfdflhI0U1nUuP5uIrs1KAUwAQ; kuaishou.ad.analysis_ph=b6db52c9e4207720bd3fd08fc704d36e54d4",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 99999,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 19,
    "nickname": "兮妹儿·716",
    "userId": "227811072",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/13/BMjAyNTEwMDQxMzI0NTFfMjI3ODExMDcyXzFfaGQ2ODdfOTkx_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; bUserId=1000011164851; userId=227811072; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAHgJUIKwvNRjhhVDp-cjEelw54yLUmTL6OqMrwvuD4DKIjkkzPlXC6V2taqprS3H9u3O7zZZw1ciPLP0MIiI4UBwnvmCm0WUt8QfvgpHfZzvWl_nCpT7nVrV1GgXKXpXTJSy1CeBfKq3fr8rEMEEXb1l4NPzTqdzjAcPPfe1amz1MLWlu-jaE8qgkjWTyaw9LkWl_xd4D6KojvSNoHWOs1-GhIJ-jd8Zkse4A6ziMrVM2OpCxciIDTScGOMo8eYdlZsAAFu3RheuVYEKBXH-07CM79b7EVqKAUwAQ; kuaishou.shop.b_ph=d728b91b2e145bcdbc9ee42dd03a472f33ad; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAavlY1EUPXY1wsSBIr7rOwiGRaDVy8KW5C7_mXTONB1LbqanDC70nve5S3abxP9aGw9I3XzTC9Yg56q8zrbgVIaEc8bHntOJhG3Ltoq5W4tYiqtjKU41B56sTGv7B75p9RcPVr_gbmgp9uWV1RMurUTowQ8uK4BHqHDDfHCpRnNNDIVJ-zSZSvOBrx4c2yMr9E1_NstRI7sGqlvA2UxbOICzXhWkNes_RSqkb7HnlW7vGhK6hJkKkdAxZJ7RKftsek4sv6MiIGLWAJBGyxmKeefpkCqYpn2XN596YBQGrz2XJr31rcO_KAUwAQ; kuaishou.ad.analysis_ph=18c149f079c0e3e502e368efea5c39abef47",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 99999,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 22,
    "nickname": "琪琪子•716",
    "userId": "20229201",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/12/09/08/BMjAyNTEyMDkwODA5MDFfMjAyMjkyMDFfMV9oZDYzM18xODY=_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; bUserId=1000036306896; userId=20229201; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAHdsE8bDgelLAQZx3u9oHMlm15MTx5sGIVmJIboXpgICe7SJuGyUb5vKiDKo6IOuuOIT8wV-GkdklQojQW4354mB1zilBVA4aq8_KgxDaGoEhUBA22jMMg4O8jANIFOmqsIS_xz9B0HVsSaLa9SYNJPYimBtUOlfuJMzH4V9UKfTOGY69wEO642W4QiMJWQ8zg6vOgq2w8Eb1Xda2JcpofEGhKN9fDRK1YSjW3fqNnL2RrNsV0iIDxwPzH1eqACtp_MhxgjklkcLJRtg0pCH08ZkefRjp8gKAUwAQ; kuaishou.shop.b_ph=826668179788568ff6c91ffc7fa1cf689059; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAQciDiy9ulT7gFtgZEMNXnYXQlyD5x3qooJfhHboe8L1sT6ZKMpQsSLOY4ZhAp812cFGh2gzmIXiQ1mTcx_DxNubnDIJkP4UHwr5o4tTVMl67nJ1xw0pU2R9YBvN9q3QPTjX8tBi8aqrvQ6XiEvTKmKQLh8fmjZBP9aYpvc9I479aqUpF9_hbFBDfZxeJJe_7J21nZv8-ljwAspgeRqy9KRg2_psNtBu3mJX1DG2kJ_xGhKZCfrvDkZPW5JtsdB6aD7xPb8iIJwSWHP0D0cfMwxneztfplNQ9tEQeF1OBwCPcThXd6eqKAUwAQ; kuaishou.ad.analysis_ph=51b781aea7acb4201454d77607ed5c3ebc1d\n",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 600000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 23,
    "nickname": "辛洋•🐑",
    "userId": "1289566627",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/11/25/18/BMjAyNTExMjUxODIwNTlfMTI4OTU2NjYyN18xX2hkNDIxXzM2Mg==_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; sellerId=103432682; bUserId=1000029096341; userId=1289566627; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAHxwk_TzZwNbqj71IeQg1q9ioJqwSYh9etlo2vI8HnDRARb2HniZJtqf6tgQwn3CBhhpYjNEM6uE70NlyXOkkcN8nwPoL3SJEGjlOUIedpTws0D4Q50qYYu1xHMAKroUNdTezu38uslCQ216thIL0nKnHFn5eK9QTJ7fRIC9JsH1QrLqQPOOcbjmxazcEZ_jOE0oj03O1PyO75ESzkYQI1rGhJHLt8Pt7EFLsNXpPl1vIIF_g4iILCZIYTVF0S-Elkv0qi6LBuM_DoqtF2X7L4QUq7ILCMzKAUwAQ; kuaishou.shop.b_ph=d8027021d0ff52106c9d04adae4910811333; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAdIOLr3sKNeQkDzOWfxl0ejpgkD4ToYg59ERupWqlGZo9HbOpk7PuqQQ5pombXvCuGfYEb7rHp53J3490od-Wn2Njty0t3Tq77FlYKhwqeqjmUfpKbGmrRNOQ28bY41RZ3fET2Y6otLSlB4FUkclrjV3rf9CdKNNY6lZl4FFDUs8VmkpgRNAj2NNDZ7smyCv50vkFI-7En6oRKyUkQVMHxhmsRcDe4gLX4W2uHGpOdlEGhLD0lY79lZNUc06quXcO9APrxoiIOhbJm8PNwamQJNPlMnwKuXjz9xr_U9YQ4gh1MF0FsnoKAUwAQ; kuaishou.ad.analysis_ph=d08a132827104d42af8a932b01f67586498f\n",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 600000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 24,
    "nickname": "可心哥哥·志虎",
    "userId": "4658786792",
    "type": 1,
    "img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/04/05/BMjAyNTEwMDQwNTAyNDdfNDY1ODc4Njc5Ml8xX2hkNTgxXzgwMw==_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 25,
    "nickname": "天宇·娇",
    "userId": "4377933002",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/05/BMjAyNTEwMDQwNTE3MzRfNDM3NzkzMzAwMl8xX2hkNjg3XzQ3Mw==_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 26,
    "nickname": "笑笑•娇",
    "userId": "305362176",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/21/11/BMjAyNTEwMjExMTM5MTBfMzA1MzYyMTc2XzFfaGQ0NzVfNjg=_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 27,
    "nickname": "一泽·716",
    "userId": "641412925",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/15/BMjAyNTEwMDQxNTE0MTBfNjQxNDEyOTI1XzFfaGQ0MTJfMzcz_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; sellerId=103432682; bUserId=1000010745417; userId=641412925; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAEXyZcWpCBCjBLOG0ROCiD7I4Ha3R_HFiv9rXP4RHZYSpHSGXXr8lGvGDdGbNKm7eheKOOqibIFC3EDuVvx97OighR-iKOa5GfEqZvH8fcIOkT4eIu5mCItXqtPYz236qpkNisoqLajUZ_JLcORE-nc-O8XNsCGcwuUuPnprfLB-KwYYKs6LrbAPwY846xB1v5gZJ5CDA_JyCHRul7gSmevGhKmF-W_lNyJTm2KnbtfN4jmymsiIDi43dpa4wS88vLu-ku2PQiCCp7bvEHqNA0Ngei1ieZ8KAUwAQ; kuaishou.shop.b_ph=7c003efb6beec2feb5e30416898505d4d43d; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAfdBIxutebbQKJn-mnppfVOPO76GHXD1dhyJ4OMgTrmMVlFGRsbliTA4RHKkPaRpL0ZaDAZXiqBcOMIGBZu3SU7FJhDpznDU57e25VSbvVBZWIZnbIxTiFJ5bffrDwkR8HpOrz-ztUP1SPYaD5J4OSIwma_XLjDx-xUFnP2VWpVJOJ51W7qtoNcEtJnViMOw72WHUfbeHyrCZboR__pZi2VrL6yMTJb_Kx4FwcsCPjfBGhJjWmlK-nwwZ0KskNTPfo86KCAiIKmKRXiWy7R66iiDpJ7e4fFOWJqHTT6dfwS_LjXvTFpDKAUwAQ; kuaishou.ad.analysis_ph=91fc58f2c98d6a7df3d77046da775e3afac5\n",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 600000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 28,
    "nickname": "文赫",
    "userId": "881758958",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2024/07/29/00/BMjAyNDA3MjkwMDQyNDFfODgxNzU4OTU4XzFfaGQ3MjNfNjg1_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 29,
    "nickname": "牌晓亮·716",
    "userId": "45672093",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/05/19/BMjAyNTEwMDUxOTEyMDNfNDU2NzIwOTNfMV9oZDE0M18xMTI=_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; sellerId=103432682; bUserId=1000006777448; userId=45672093; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAElhb3eDGk0dVLm8Zgj7gM8P8tm5O06JUt_fwFZM7nVsp_E9oD9_A550z0In-nRJQn0iKDmh2S972UcS2x0HigwOb7SXJM31CWIKAQWxPjNcZIxx53hlF2bYQBwRSykVprDnLuru0UfzMUrU33vpP-zffhi--m0f3EB-D26zi95hC7FXJ3IFoQgK35W-gauF-UDEmlcuiB8IgAtIByDaEsLGhJSPwykspxJ_lwL1FDHlEAhP1IiIDW10MKe-kqaYyvslRL3AUyOqywUmgtbv88-_hWssr4nKAUwAQ; kuaishou.shop.b_ph=729b4fce2be2df05e93ae4c2857b5be09c3e; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAWQ5foHPY8rU6_-moX-z0QVeqHj1ywdrC1KHVqP7EH2-YcAoiP1NtZwMT2_GbxglAuhlfUpuDmNcWwco7AhtcPq9j8-jZwWxkm-U2sdzOd-OkGrES8FV_ut6eadDmeRo06_qF6DGi261J8mOhUodynm-trA5YdD1Km-XPS0DVafsP6IQmUa_JBqU20403fgDsvPhPcrC47j13QdWvXR4z3emkVaTrRBNry_W6OwlbkPTGhI2Q4Zf7Fjy6K-OkplcWEkYXd8iIBd8k5VmNSSh7cUKC9wlShlI_Za2u2fVEYs7ftPtX3WTKAUwAQ; kuaishou.ad.analysis_ph=318c98cc3ec191a8e5f73c0841fd80138d03\n",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 600000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 30,
    "nickname": "柏秋•716",
    "userId": "5825207",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/17/BMjAyNTEwMDQxNzM0MTJfNTgyNTIwN18xX2hkNzgzXzM3NQ==_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; sellerId=103432682; bUserId=1000007206964; userId=5825207; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAHvK4qNVu5qOKwcKWo4A0-X7dtJB2o8iBYVpeHfooLMNgio_3R5981lFSaWTrYFV27jdBjvkSjMttOFPMv2lI_roajnCsku1H8X9XnOTLcD6FJhEtYXwbte-lgdbzVQXC29FFMm1TrbZRjznJu3IrAct5ZxOtrT8uBUXaQixSDKC0uvAfhzeztLH9bcpUeTB3K87uhGfBedM5WoP8ZL267kGhI6AjZAm21RFhrJYP79BslttNciIIgYszKlNkzvRQSgqzAEsU7FhG4p6a4kQfyyNdHpkc_jKAUwAQ; kuaishou.shop.b_ph=9a5df6b269449eb9809ecbeaedc7c005c866; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAe5tk9rol_eohPy_pWHcsGhDqxqGkKQ80cZqdqQvX3wYCllHk-47WxYJ2C-Xuw3NRZeydMkfXZVknBsCRRo2VMFscTRvGygbTaLaEBJ4N5BYohVpaDgWyhE-ux96BLcHJTjuj1LXJdSP6qrCKTOc65pqrvYy_rwmNjfW_G7mIFB9Jz39iihKfcko_hzylaGJViXUT_Vya0GBZSgJ65l3nZ9LxplafCAvSwPr33tmGmhFGhKd4QgDwlODTx7HY4I_0IJB44IiIHr95gp39AVT9HJajQcYoZABcOAaaUA16nXsj-xKNm3uKAUwAQ; kuaishou.ad.analysis_ph=9ec84f149eb19e75471c4f6d136f527f375b\n",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 600000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 31,
    "nickname": "胡雪莉·志虎",
    "userId": "95992100",
    "type": 1,
    "img": "https://p5-pro.a.yximgs.com/uhead/AB/2025/10/21/02/BMjAyNTEwMjEwMjQ1NThfOTU5OTIxMDBfMV9oZDE5OF84MzA=_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 32,
    "nickname": "甜妹·雅儿",
    "userId": "3676208364",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/18/BMjAyNTEwMDQxODI4MjlfMzY3NjIwODM2NF8yX2hkMTc2XzM2OQ==_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; bUserId=1000435741931; userId=3676208364; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAF52k9hVlphKMZhdEYyFOkImzqb6qro7UdRmXBdnuZLPQJjkewuFzb_YdZUwIadcqMbAT4VDcrqs2JZzznTzFn0ss_vpP0ETAlhPPWbteKxtlPM_2vZ13H4BTFK_gOBBd2oP_dK7vO3ictCWuzkCFTk9_NTaGC31IRBkoDddTOQXv7NC23lXGTdL7SMz8AYRrcFnO1JKcXN2gl27wddXtnzGhJx70cBBaGVtEpnSlNxog9ZoqoiIPVrsLFSemKhrnl567m2NNHC-IUbF8u8b91SIWUFviNsKAUwAQ; kuaishou.shop.b_ph=8a48171cce730c62937cc6e3e086056e41bb; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAVVbA7Jirof_e_C4i5MqDe19CbgR1awW__ptLv843sbO7z0I9fsWbGd-xgiEmMaG0vIC98k4otCC5bmWwvvg1F5D2aj7yxlik9qHTmuaG_RsmIX_O53qtM5-DgQdW8P1OGQD5wfVqF88_869YscsbBb5zpSNJA_Ew2ikyYjIsBtO-wsvk6V3Nu3A14jWDm0Q1OYiRc39YgD-q8iCBTRkZeWLEYe79yU4gCm4aMD4zR-XGhLbSDb7aGsw7p2CxsASTOzcpTEiIGKPeZUI6LLElNhxEQm6FSDZ2fdokVeNj-_Vm9n6GjuUKAUwAQ; kuaishou.ad.analysis_ph=ba1af45f2483a65dec613bdcf217b0e05a67",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 600000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 34,
    "nickname": "扛刀baby·志虎",
    "userId": "4187716321",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/21/BMjAyNTEwMDQyMTA5NDRfNDE4NzcxNjMyMV8xX2hkMjI0XzQ0NQ==_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; sellerId=103432682; bUserId=1000445908067; userId=4187716321; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAEskygyb5xcmm72M-Eu-pjl3qFGXKxGvVZO8FG2Iz_vcGgOhpg0lqJEVq9H8NtQH_0nP0OGiahdyOsk8LOPMmSk0H456Gwp6V4X6k0pT3QP7qdufVfbgtwKVMkQ-NaUy07AwgnfzExu4anrnh_Hp7OrPh4rWDD_AVbcbDeBRvCe6labXMxS-20RAuNnBpRI86qR7jqDBk9k4LJUKUYFG8mkGhKmF-W_lNyJTm2KnbtfN4jmymsiIFg4hGzE8l9Q4Rxh2nPpGexZIqFwbNICJl73jMF5_nAcKAUwAQ; kuaishou.shop.b_ph=353f9b8efdc1a3364fc961cd4261e6fa7930; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAfffgYEZdKZK9X5_ct9RuB5jTi3CWN9LOe7I09sAclxdAaVeekrGLFFSsV8KEjgLq9_L9xjj1-FTw_WrIbVSqoZ6UCLyb60RBbVsP6IkEaUndq0I0GVa3TIcBgfsO1J_ZjXuoMrfMoWs8DceIs5MQP4x1uPiRn4BffR1TSFEhr55TxtqWA3x4eGgpDi3aqYOfrsFRPhiCoXw5qCT-ee5Oll6Cb29lP8YRq5t8zV_u-nNGhLBQhRfbrn6PLR9rKF_P-8CoiUiIP4F36lzXJhvR8oBLFPnOOqRC6lOL0KPsc5MdevqwPHeKAUwAQ; kuaishou.ad.analysis_ph=7d5608d7e098436da9be4d7639112c42e148\n",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 600000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 35,
    "nickname": "堇一•辛洋",
    "userId": "2347908554",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/05/14/BMjAyNTEwMDUxNDE5MTJfMjM0NzkwODU1NF8xX2hkODBfMTQ5_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; sellerId=103432682; bUserId=1000494409960; userId=2347908554; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAF9RoM6Vt0wHH9bE8YPJRfiMfIPSWwmxdPhgeqArKIiRRqsAFDIemBhPdhJfmXtGrQD-at-0sCNPkOovRwPSBnIylCs7FEJ9YCoPZPyUrZaGgljgx8hdmnJs1gAKKFFk8zAT6bzBuwR64EhhiXvWRxy4zhcD8hArYRKYzGN1v2rcc9TUGzU8KDooSx_t2ArKpu6uQ9NMe0V8-3QQE9bxNXdGhKmF-W_lNyJTm2KnbtfN4jmymsiIGkdHtIPLw9u7n7XHdTwYtRr93nrcFBXLgRwpb3Oq15tKAUwAQ; kuaishou.shop.b_ph=082406854fdcb98cfa86702ec414a867881b; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAWcKaZzgCy93juZIIc70mdMhVB33wbcI_otV1OZszxmnkLHNv1UJkr8wA90us_WlNdYpjBtv7M9teAh2lFNUTHE9YwYaoYUM5DBen9x3UA1Ww_WVBwrQNhsiZ5PzYVy8z-Q68mMoqoJ9UciiFIS92pcCjB9pibo0zek8iQlwTAowAc5P-jwzc_kDYVaGBO8OWprswlOGEIbmsEORyp42PHUDkgnQWu61_FhDS6IJJpBpGhLbSDb7aGsw7p2CxsASTOzcpTEiIMvlvlrl-mCmE0Xi9zqRKz_vpxVpwVtj5Dei3V4WG5KLKAUwAQ; kuaishou.ad.analysis_ph=e107dd2a676bfdb1d14be6fab100d906781f\n",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 600000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 39,
    "nickname": "小欣·娇",
    "userId": "709084778",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/08/00/BMjAyNTEwMDgwMDQ4NTFfNzA5MDg0Nzc4XzFfaGQ1NV8xNzk=_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; sellerId=103432682; bUserId=1000255202329; userId=709084778; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAG9AQSd0emVbVWZkTInyuVIZ9spOCpuq9mT45puKQbv3lBD3QPZSjr0zDMYgdtqoYpuGTuNSlYIFnoQREvXLIHSM-52vtjG9lxsznzjxYzOQaZyhdkXzzdggDAvn69ZInkTrlrJNTkhhHtkqH7kRysnVFx-q2jxrbiX27UNQP_hwJQzSoHWbK8Z86RC8V6eGHFplyIoURVAvaWd4dvcUGVpGhJbNLK1AM9bncnjnr5P1Ut3hAIiIEUeDl6eCZZfLerPa3kql4Lu22LHfJo_VfYtMIEgz4uYKAUwAQ; kuaishou.shop.b_ph=c60e098fd6c1e7e7f204e763f447283467a9; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAdzXy1UkBbPpoxqxsPqd_AvJmTAYbGLggmacGUJbXy11gq3M7QmxU7S790N9ZXMzDTFP3BzufnT9DzsesEZ-ltHdM_GofbqppMRPWpM2IcbsvxtEyhIU-u8R8MMy2pXtMnc-f11DjR3h4L0Q5Jj68eB6ypxodC2AJFrO1bKKaNeuYNIC4BaOfbwYaPF2YxsRnntQ4oNOdMbp5PDExhjeB27J9_g8x-Kas1iKjjtOivd7GhLbwz68ZkiTB3sY69L_Qrle9OgiIDCYS9ledKyxXAHZ9QzlODBoVv5kmqec83LnrFlKKffGKAUwAQ; kuaishou.ad.analysis_ph=cfe178c7c4bdefb630ee005217e9e0eef840\n",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 600000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 40,
    "nickname": "陈举举·716",
    "userId": "94198747",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/20/04/BMjAyNTEwMjAwNDU2MDZfOTQxOTg3NDdfMV9oZDMxN181OQ==_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 44,
    "nickname": "小妮•辛洋",
    "userId": "172766383",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/21/BMjAyNTEwMDQyMTE1MTBfMTcyNzY2MzgzXzFfaGQyNTVfMjU1_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; bUserId=1000470983838; userId=172766383; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAE_rrvVKhBGH8yu88U6wJxiCbguTgf5wzsUjqNicaoWA-FIX3yhTxNizJ0S2AmxG5DwcQXa7PYgKsBam6truibtqRktvnngdqlxdZTzD7I8UKP__VFqO_CodVvdj7xqZphQkedKMCIdO9xX-80WiirrtnOpklsqtFzh1e1Sa8tEoaKuRzJg80pWyZkq9OImzyaYFIgWhBvInXNEkdq4Q0FiGhLY1PpTmwXZ7exgP76r5BIkpxIiIEbCYCvngzSi7CZ83dnyQjJ_1ZdIY2Y2jQ6McncjtKAQKAUwAQ; kuaishou.shop.b_ph=a220244ea12987c63fda847f11bd93778dee; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAc1G70THY4FxVnddZdcN835FvewSCoMspDreuwisD4JyUdFGy633Rkmqkiq2w--m4M0WFkS_q4k7gtzLIKti0i6VaoYzM2paOGBTAADzmtYrPjCLHfmxRCoYy79A5EMGjfRkbCAdfpFoxoNJsw-pfR2DlZzTGQcYPPZqYvGj1GvQXAwNT3p8UptxP9wptT0tFfecHpgEPqv5MnNuWMTpkt_7TveXbMBXBkzDXVyizf-PGhIszidpTUyKE-jZUURCKcG_ackiICnO7OqdjDwueusbDoH4kvLsWUsWFi-xldpzQgu7-xy3KAUwAQ; kuaishou.ad.analysis_ph=aa4bf46afa4e667575930e2510743a0047e6\n",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 600000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 50,
    "nickname": "子画·志虎",
    "userId": "1391295492",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/19/BMjAyNTEwMDQxOTEyMzBfMTM5MTI5NTQ5Ml8xX2hkNTQzXzI2NQ==_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; sellerId=103432682; bUserId=1000021863132; userId=1391295492; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAE2yKrhNukc9xqWE-q0HflbHFhxg9AXQyAGS38stJyeqWeTz1KD4tb1Jbao0pzFFvn6pgCDymXyZz1bHG4fE62SglSjL5N7CZgdPo7G_ZcBiv10mWm8UAEqEtYkg52W8z72LrmnceeUCrwKXRqBLF4mGOLSTcSLqHVHS8dFXXMr3xeoiMDXtdEN9bzP0Dv0mEZfOhcCnlx0ZJ0DxSZd0RcLGhLo_Z2VG4WxceKArz4eXu24hPEiINFNLk_Id-ftFlC1rEEjczJv7YhtcbK_PoJmTd9aRoc4KAUwAQ; kuaishou.shop.b_ph=99f5d2089016f66eac85b5adb11c88679f3b; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAfID2JC1vteAy9nNT3JMLGNYxp2hLCY5uLFNYq9I-ebLx83Kh01hkDSPW2IGtTgvPXvjNU4Lm9dBEmv8Y9TJRjmS9eTLFvAMiMK7s7D7-yBX5KWWxb5bSae-1nRrCeWNn1vTPYV08ES5d2F0ADyoiFZvt-051ssz9ZHdGZGAsCB4hcyGTgaz6gEdCcWytnGdfehT8hGH53hN4EJ23nZlZkfNrZvexyK3gllRlX-KDIh5GhKfnYlfKFPaF-z---LLO1WfrxQiIK9nO-CCXKxcD-sohNLxs1k6TQHGxjDDr2Dm-lsNiilAKAUwAQ; kuaishou.ad.analysis_ph=3c8d8df2590364b288b5915529789bddcc43\n",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 52,
    "nickname": "冠冠•辛洋",
    "userId": "1340215466",
    "type": 1,
    "img": "https://p1-pro.a.yximgs.com/uhead/AB/2025/10/05/09/BMjAyNTEwMDUwOTE3MThfMTM0MDIxNTQ2Nl8xX2hkNDQzXzYyNQ==_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 53,
    "nickname": "顾洋•716",
    "userId": "1135009365",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/05/BMjAyNTEwMDQwNTA2MjZfMTEzNTAwOTM2NV8xX2hkNjYwXzY2_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; sellerId=103432682; bUserId=1000007206818; userId=1135009365; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAETLn9ebn1046BqdNblkrMd8jZEkarBXOmm1ZG_nVFnAU60j9ibALx3Afw0SgR_pJBJHhlpaO0yNsOtIarEoGX96GzKASPW5CmVZqWBi0eXbTyhwQrA3jtC-YJbPfhxKZb_kOy_P74U8OwUX9neE15r-seyBA2MHBjmwSjuyiHvG2CdbX9LZCOA3PCHQbDNNag7Jn3BBO8W1J3Xsfa7ioMVGhLJEp5dRe8bRzILp4WlbdDTnPsiIOA2aYGW35BtxHSyCImic2La3dlZDqYB809PuujTFz8YKAUwAQ; kuaishou.shop.b_ph=7f14e83b91e698c1ff1bc441b507ad72ea1a; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwARzuoKFvljNEcauuIWhX49WcLCGQdFP9JVPge5oH9NOvOu37enMtJSgRvLBm9nSuYn694A2eJkgDLRYPM_xxXXF460_y_Oj4apuEqc-4ghw4x19LanEygs08ryhQTm-PRlXU-Txyc2lv_IbuNchUKrgWJmSEl7VTkEEmkp2Jf03iFLb1B--2IGjPq6kESWKA0LGxlFucCl9749Cb70Y_w5YK7KCj5K2pAk8oxYwpy0O0GhJHjsgHxsdoyFjPAaJV7bM6WXAiIFczaR5icIdbNcPkR6qUdxAEeyqS1HS7C-voBKZ-IHi0KAUwAQ; kuaishou.ad.analysis_ph=a0c8683fb0abc7701b8b39faa4370e14eebf\n",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 54,
    "nickname": "虎牙妹妹•亮",
    "userId": "1392669964",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/08/03/BMjAyNTEwMDgwMzM5NTNfMTM5MjY2OTk2NF8xX2hkODM4XzQwMg==_s.jpg",
    "cookie": "did=web_f6lrtddovu38r4smkgjw52rmxau9wbof; sid=kuaishou.shop.b; sellerId=103432682; bUserId=1000052074416; userId=1392669964; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAGJoeJKN498d80GhK6SvfLb3_usNh80-oMQqTsBhhNPfmBuyAlAAxNm5eRiJLC99wP5IynE5-a6PDwItAbj5ewXobLiyNw-CvEzLVWht5xcH-a-o9GsZu1NbikynCVD-ol4Ux4-Ye3k4IjgmGIkwXROmrWfdU1HEQ16igyENwWQ4eboKK86Sv19RtnqoIzvc5Ih1nwHOesxSLLU37MvcRX6GhIoDb6opzlycuz0NgNjDyqUN2IiIDaJwpWYsTkcqWzAjiJOKHXFZsiGLDLpbQur5gkirTJ1KAUwAQ; kuaishou.shop.b_ph=7e7c55f82fa9e52445d49bb0a84621e82318; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwASbfnN0MZa08NlloxqgQpjx_tV4xJCaqEDiHhYjEMKKjpnQ2GYTkIGCyF1QCyKnqVUD-BvtKNfr9PZkRRVFZ4ku9xUOWhx6jRrFVTVN6Fu1Y7hc3-qIat_tVmZYF5d0ccXmg-GVqmcfVQLGdhWO31I28pnbhaMWG32yJSA7qvIV5byycJayaYuv0O1LmGman2P9rj1OYakw0wEfPYQbAeMHH_NDompfUlSPWaqJrqDBXGhLbSDb7aGsw7p2CxsASTOzcpTEiICve-Wv8cfe5cmEnqUrWp9mS_vxzvWnsdjTrV2byhyJ1KAUwAQ; kuaishou.ad.analysis_ph=ef01ac56eafb1335f6f7d1c84ae6edc75687\n",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 600000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 62,
    "nickname": "云朝·志虎",
    "userId": "4766844132",
    "type": 1,
    "img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/09/04/BMjAyNTEwMDkwNDEwMzhfNDc2Njg0NDEzMl8xX2hkNjQ4XzgzMg==_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 68,
    "nickname": "王子凡•亮",
    "userId": "4750400152",
    "type": 1,
    "img": "https://p1-pro.a.yximgs.com/uhead/AB/2025/10/10/21/BMjAyNTEwMTAyMTE2NDhfNDc1MDQwMDE1Ml8xX2hkODlfOTg5_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 69,
    "nickname": "浩森·娇",
    "userId": "1214372729",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/10/21/BMjAyNTEwMTAyMTE2MDdfMTIxNDM3MjcyOV8xX2hkMzUxXzYw_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 76,
    "nickname": "困困·辛洋",
    "userId": "4339498161",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/07/20/BMjAyNTEwMDcyMDA3MTZfNDMzOTQ5ODE2MV8xX2hkMjQ3XzU5Nw==_s.jpg",
    "cookie": "_did=web_2245111762335533; did=web_b9b2pnpv2f94mqyrtodegea6dooklkn7; bUserId=1000503087968; userId=4339498161; merchantSellerId=4339498161; sid=kuaishou.shop.b; merchantSessionKey=1779087276355_b154d91e1aa2921882eb0be9af4059af; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAGfa5edEZ6DTP5nk5R3i_c3V_IytBBOa4Z7Z4lCKbEddaF6qkcU0Mcl9c8HMLUQE1zf7fHSIIjQoN3p8VSfQntbdy-FYucTTZbIfvrbVT86pujKv_9QAEt26fFfMX0KrfRiPYD5CmHGAyfbzKwmsj4Il9a-7kXYx4WoytTdlw0_KjhRX5Ro49uk5bDzpwcer02lCTfn1dKMxjYr4Z5ISEosGhLSubyi-uEBAthqCoUoWxNxjR0iIFf9IG_dG2fwEhKd_nGLphc1Ufcd6_5sDcOmDwiBWu1FKAUwAQ; kuaishou.shop.b_ph=beec46fe4cefe42810aa90e0ade3def55b3e",
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 77,
    "nickname": "姜姜·亮",
    "userId": "1026423626",
    "type": 1,
    "img": "https://p4-pro.a.yximgs.com/uhead/AB/2025/10/21/14/BMjAyNTEwMjExNDExNDVfMTAyNjQyMzYyNl8xX2hkNjE1XzMz_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 79,
    "nickname": "圆妹儿·志虎",
    "userId": "1728785253",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/08/14/BMjAyNTEwMDgxNDU5MjBfMTcyODc4NTI1M18xX2hkNzYyXzM5OA==_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 82,
    "nickname": "牙牙.志虎",
    "userId": "4937554679",
    "type": 1,
    "img": "https://p1-pro.a.yximgs.com/uhead/AB/2025/10/12/15/BMjAyNTEwMTIxNTQ4MTdfNDkzNzU1NDY3OV8xX2hkNTAzXzIzNA==_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 83,
    "nickname": "心炫☀️·志虎",
    "userId": "1420270994",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/06/23/BMjAyNTEwMDYyMzE5NDlfMTQyMDI3MDk5NF8xX2hkMzcyXzM1OQ==_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 87,
    "nickname": "李权·志虎",
    "userId": "4038252896",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/23/07/BMjAyNTEwMjMwNzUwNDNfNDAzODI1Mjg5Nl8xX2hkMzM4XzgxMQ==_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 88,
    "nickname": "丁楠·志虎",
    "userId": "2853154921",
    "type": 1,
    "img": "https://p1-pro.a.yximgs.com/uhead/AB/2025/10/05/07/BMjAyNTEwMDUwNzI2NTlfMjg1MzE1NDkyMV8xX2hkNDAwXzQ1NA==_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 89,
    "nickname": "伯乐意·志虎",
    "userId": "1691245538",
    "type": 1,
    "img": "https://p1-pro.a.yximgs.com/uhead/AB/2025/10/10/21/BMjAyNTEwMTAyMTE1MThfMTY5MTI0NTUzOF8xX2hkMjc3Xzg3OA==_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 90,
    "nickname": "王摆摆·716",
    "userId": "3429662806",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/11/17/19/BMjAyNTExMTcxOTExMTZfMjE1MjQ2NDYyXzFfaGQ1MzRfNjEx_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 92,
    "nickname": "孙浩南.志虎",
    "userId": "664592323",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2026/04/25/17/BMjAyNjA0MjUxNzUyNDNfNjY0NTkyMzIzXzFfaGQyMDVfODQ3_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 93,
    "nickname": "美竹.志虎",
    "userId": "1260921214",
    "type": 1,
    "img": "https://p5-pro.a.yximgs.com/uhead/AB/2026/04/27/15/BMjAyNjA0MjcxNTQ4MTRfMTI2MDkyMTIxNF8xX2hkNDQwXzkxMA==_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 94,
    "nickname": "语宝.志虎",
    "userId": "2927047162",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2026/04/27/15/BMjAyNjA0MjcxNTEzNDhfMjkyNzA0NzE2Ml8xX2hkNzFfODU1_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 95,
    "nickname": "文博.志虎",
    "userId": "1020742427",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2026/05/13/23/BMjAyNjA1MTMyMzMyMTJfMTAyMDc0MjQyN18xX2hkNTM3XzgzMg==_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 96,
    "nickname": "小源.志虎",
    "userId": "5383394737",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2026/05/15/00/BMjAyNjA1MTUwMDI3MjVfNTM4MzM5NDczN18xX2hkNTA3XzExOA==_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 97,
    "nickname": "小姝.志虎",
    "userId": "4966901635",
    "type": 1,
    "img": "https://p4-pro.a.yximgs.com/uhead/AB/2026/05/13/23/BMjAyNjA1MTMyMzI4NDVfNDk2NjkwMTYzNV8xX2hkNTM0XzE5OQ==_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 98,
    "nickname": "一面.志虎",
    "userId": "1301982067",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2026/05/14/00/BMjAyNjA1MTQwMDAwNTlfMTMwMTk4MjA2N18xX2hkNDMxXzY1MQ==_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 99,
    "nickname": "灵儿✨·辛洋🐑",
    "userId": "4747367688",
    "type": 1,
    "img": "https://p4-pro.a.yximgs.com/uhead/AB/2026/05/26/02/BMjAyNjA1MjYwMjA4NTdfNDc0NzM2NzY4OF8xX2hkNjA4XzQ1NA==_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 100,
    "nickname": "小静·辛洋",
    "userId": "1105905919",
    "type": 1,
    "img": "https://p4-pro.a.yximgs.com/uhead/AB/2026/06/10/21/BMjAyNjA2MTAyMTM1MDZfMTEwNTkwNTkxOV8xX2hkNjM0XzQwMQ==_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 101,
    "nickname": "丸子•辛洋",
    "userId": "2696343064",
    "type": 1,
    "img": "https://p4-pro.a.yximgs.com/uhead/AB/2026/06/06/16/BMjAyNjA2MDYxNjIwMTNfMjY5NjM0MzA2NF8xX2hkNzgwXzM5NA==_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  },
  {
    "id": 102,
    "nickname": "大川·志虎",
    "userId": "2417965047",
    "type": 1,
    "img": "https://p2-pro.a.yximgs.com/uhead/AB/2026/05/16/00/BMjAyNjA1MTYwMDIzNTFfMjQxNzk2NTA0N18xX2hkNDgyXzQzNw==_s.jpg",
    "cookie": null,
    "gmvTodayAmountDouble": 0,
    "diveAmount": 10000,
    "giftTodayAmountDouble": 0,
    "createTime": 1744725047000
  }
]


// WEBPACK FOOTER //
// ./src/components/page260622/data-0622.js